<template>
    <div>
      <div class="login_info">
        <!--手机号-->
        <div class="form_item">
          <p>{{$t('m.phone')}}</p>
          <div class="form_inputbox">
            <div class="seledArea" @click.stop="showCountryFun">
              <img class="flag_icon" :src="selCountry.logo">
              <span class="fc-pad-lr-min">+{{selCountry.countryNum}}</span>
              <img class="select_icon" :src="(showCountry && $store.state.isShowSelArea)?require('../../assets/img/icon_up.png'):require('../../assets/img/icon_down.png')">
            </div>
            <input class="login_input" type="text" v-model.trim="mobile" oninput="value=value.replace(/\D/g,'')" minlength="6" :placeholder="$t('m.user_enter_bind_phone')" />
            <div class="selarea_box" v-if="showCountry && $store.state.isShowSelArea">
              <sel-area @countryOption="countryOptionFun"/>
            </div>
          </div>
        </div>
        <!--验证码-->
        <div class="form_item">
          <p>{{$t('m.vericode')}}</p>
          <div class="form_inputbox">
            <input class="login_input smscode_input" type="text" v-model.trim="code" oninput="value=value.replace(/\D/g,'')" maxlength="6" :placeholder="$t('m.input_vericode')" />
            <div class="getcode">
              <send-code :areaCode="selCountry.countryNum" :mobile="mobile" :scene="5"></send-code>
            </div>
          </div>
        </div>
        <!--密码-->
        <div class="form_item">
          <p>{{$t('m.passwd')}}</p>
          <div class="form_inputbox">
            <input class="login_input smscode_input" type="password" v-model.trim="passwd" maxlength="20" minlength="6" :placeholder="$t('m.passwd_placeholder')" />
          </div>
        </div>
        <div class="fc-flex-center">
          <div class="login_btn" @click="addPwd">{{$t('m.Confirm')}}</div>
          <div class="login_btn" @click="cancelPwd">{{$t('m.cancel')}}</div>
        </div>
      </div>
    </div>
</template>

<script>
    import {getCountryMsg} from "@/api/common";
    import sendcode from "../../components/sendcode";
    import SelArea from "@/components/SelArea";
    import {forgetPwd} from "@/api/login/login";

    export default {
        name: "forgetPwd",
      components: {
        "send-code": sendcode,
        "sel-area":SelArea,
      },
      data() {
          return {
            selCountry:{},
            showCountry: false,
            mobile: null,
            passwd: null,
            code: null,
            btnLoading: false
          }
      },
      methods: {
        /**
         * 设置密码
         */
        addPwd() {
          if(this.mobile === null || this.mobile === undefined || this.mobile.length === 0 ) {
            this.$message.error(this.$t('m.user_enter_bind_phone'));
            return false;
          }
          if(this.code === null || this.code === undefined || this.code.length === 0 ) {
            this.$message.error(this.$t('m.input_vericode'));
            return false;
          }
          if (this.passwd == null || this.passwd.length < 6 || this.passwd.length > 20) {
            this.$message.error(this.$t('m.passwd_placeholder'));
            return false;
          }
          const data = {
            mobile: this.mobile,
            passwd: this.passwd,
            code: this.code,
            lang: this.$i18n.locale,
            areaCode: this.selCountry.countryNum
          }
          forgetPwd(data).then(({data}) => {
            // 0：成功 1 验证码问题 2 参数异常 3 该手机号未注册
            let state = data.data.state
            if(state === 0) {
              this.$message.success(this.$t('m.oper_success'));
              this.$emit('cancelPwd', 1)
            } else if(state === 1) {
              this.$message.error(this.$t('m.vericode_error'));
            } else if(state === 3) {
              this.$message.error(this.$t('m.phone_not_reg_error'));
            } else if(state === 2) {
              this.$message.error(this.$t('m.oper_failed'));
            }
          }).catch(() => {})
        },
        /**
         * 取消设置密码
         */
        cancelPwd() {
          this.$emit('cancelPwd', 1)
        },
        showTab() {
          console.log('forget pwd tab show')
          this.getCountryMsgFun()
        },
        //获取默认区号
        getCountryMsgFun(){
          getCountryMsg().then(({data}) =>{
            this.selCountry=data.result;
          })
        },
        countryOptionFun(val){
          this.selCountry = val;
          this.showCountry = false;
        },
        /**
         * 显示区号下拉列表
         */
        showCountryFun(){
          if(this.showCountry && this.$store.state.isShowSelArea){
            this.showCountry = false;
            this.$store.state.isShowSelArea = false;
          }else{
            this.$store.state.isShowSelArea=true;
            this.showCountry = true;
          }
        }
      }
    }
</script>

<style lang="less" scoped>
  .image-slot{
    width: 100%;
    height: 100%;
    /*display: flex;*/
    /*justify-content: center;*/
    /*align-items: center;*/
    /*background: #f5f7fa;*/
    /*color: #909399;*/
    /*font-size: 14px;*/
    /*border:1px solid #999595;*/
  }
  .sendcode_box{
    display: flex;
    align-items: center;
    border-bottom: 1px solid #f3f3f3;
    .login_input{
      flex: 1;
    }
  }

  input::-ms-input-placeholder {
    font-size: .18rem;
    color: #999;
  }
  input::-webkit-input-placeholder {
    font-size: .18rem;
    color: #999;
  }
  .box{font-size: .14rem;}
  input {
    outline: none;
  }
  .login {
    &_title {
      font-size: .36rem;
      text-align: center;
      padding:.67rem 0 .48rem;
      &_sm {
        font-size: .3rem;
        margin-bottom: .4rem;
      }
    }
    &_info {
      .form_item {
        margin-top: .32rem;
        position: relative;
        p{
          font-size: .18rem;
        }
      }
      .login_input {
        width: 100%;
        height: .54rem;
        font-size: .18rem;
        line-height: .3rem;
        border: none;
        padding: .1rem 0;
        box-sizing: border-box;
        background-color: transparent;
        color: #333;
      }
      .code-pic-box{
        border:1px solid #999595;
        cursor: pointer;
      }
      .code-pic{
        width: 1.3rem;
        height: 0.5rem;
        display: flex;
        justify-content: center;
        align-items: center;
        background: #f5f7fa;
        color: #909399;
        font-size: 14px;
      }
    }
    &_btn{
      min-width: 1.4rem;
      max-width: 3rem;
      min-height: .28rem;
      padding: .1rem;
      font-size: .18rem;
      color: #fff;
      text-align: center;
      background-color: #008AFF;
      border-radius: .4rem;
      margin: .48rem auto 0;
      cursor: pointer;
      display: flex;
      align-items: center;
      justify-content: center;

    }
  }
  .form_inputbox{
    display: flex;
    align-items: center;
    border-bottom: 1px solid #cdc8c8;
    position: relative;
    span{
      font-size: .18rem;
      // color: #888;
    }
    input{
      flex: 1;
      // padding-left: 1em !important;
      border:none !important;
    }
  }
  @media only screen and (max-width: 767px) {
    .login_title{
      padding: .38rem 0 .18rem;
      font-size: .4rem;
      &_sm{
        font-size: .32rem;
        margin-bottom: 0;
      }
    }
    .login_info {
      margin-bottom: .4rem;
      .login_input{
        border-color: #e4e4e4;
      }
      .form_item{
        margin-top:.32rem;
      }
    }
    .login_btn{
      min-width: 1.5rem;
      max-width: 4rem;
    }
    .login_btn,.login_info .form_item p,.login_info .login_input,.changetxt{
      font-size: .26rem !important;
    }
    .form_inputbox{
      border-color: #e4e4e4;
      span{
        font-size: .26rem;
      }
    }
  }

  @media only screen and (max-width: 540px) {
    input::-ms-input-placeholder {
      font-size: .24rem;
    }
    input::-webkit-input-placeholder {
      font-size: .24rem;
    }
    .login_input {
      font-size: .24rem !important;
    }
    .code-pic-box{
      border:1px solid #999595;
    }
    .code-pic{
      width: 1.3rem;
      height: 0.5rem;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/login/forgetPwd.vue